export const animationsTiming = {
  delay: 0.001,
  duration: 0.4,
}
